export default {
  time_options: {
    asap: {
      title: 'Prima possibile',
      description: 'Pronto in {{time}} min',
    },
    scheduled: {
      title: 'Pianifica per dopo',
    },
  },
};
